const LOG_EVENTS = {
  INTRO: {
    action: { element: 'intro-continue', type: 'click' },
    webActionTop: { element: 'web-intro-continue1', type: 'click' },
    webActionBottom: { element: 'web-intro-continue2', type: 'click' },
  },
  SELECT: {
    selectCard: { element: 'email-selected', type: 'click' },
    action: { element: 'email-continue', type: 'click' },
  },
  ENROLL: {
    sendTab: { element: 'how-it-works-send-account', type: 'click' },
    splitTab: { element: 'how-it-works-split-account', type: 'click' },
    consentLink: { element: 'how-it-works-consent-statement', type: 'click' },
    agree: { element: 'how-it-works-agreement-checked', type: 'click' },
    termsLink: { element: 'how-it-works-terms-and-conditions', type: 'click' },
    action: { element: 'how-it-works-authentication', type: 'click' },
    webSendTab: { element: 'web-how-it-works-send-account', type: 'click' },
    webSplitTab: { element: 'web-how-it-works-split-account', type: 'click' },
    webConsentLink: { element: 'web-how-it-works-consent-statement', type: 'click' },
    webAgree: { element: 'web-how-it-works-agreement-checked', type: 'click' },
    webTermsLink: { element: 'web-how-it-works-terms-and-conditions', type: 'click' },
    webAction: { element: 'web-how-it-works-enroll', type: 'click' },
    webBackAction: { element: 'web-back-to-amex.com', type: 'click' },
  },
  ERROR: {
    profile: {
      ineligible: { element: 'account-profile-ineligible-error', type: 'click' },
      already_linked: { element: 'account-profile-already-enrolled-linked-error', type: 'click' },
      update_default_card: { element: 'account-profile-already-enrolled-linked-email-update-error', type: 'click' },
      enrolled_not_linked: {
        link: { element: 'account-profile-enrolled-not-linked', type: 'click' },
        close: { element: 'account-profile-enrolled-not-linked-close', type: 'click' },
      },
      unauthorized: { element: 'account-profile-system-error-close', type: 'click' },
      error: { element: 'account-profile-system-error-close', type: 'click' },
      invalid_partner_session: { element: 'session-expired', type: 'click' },
    },
    accounts: {
      ineligible: { element: 'post-accounts-ineligible-error', type: 'click' },
      no_email_on_file: { element: 'post-accounts-no-email-onfile', type: 'click' },
      user_already_enrolled: { element: 'post-accounts-users-already-enrolled', type: 'click' },
      already_enrolled: { element: 'post-accounts-users-already-enrolled', type: 'click' },
      no_ssn: { element: 'post-accounts-no-demographics', type: 'click' },
      no_dob: { element: 'post-accounts-no-demographics', type: 'click' },
      no_address: { element: 'post-accounts-no-demographics', type: 'click' },
      no_name: { element: 'post-accounts-no-demographics', type: 'click' },
      demographics: { element: 'post-accounts-no-demographics', type: 'click' },
      enrollment_error: {
        retry: { element: 'post-accounts-system-error', type: 'click' },
        close: { element: 'post-accounts-system-error-close', type: 'click' },
      },
      error: { element: 'post-accounts-technical-error', type: 'click' },
      invalid_partner_session: { element: 'session-expired', type: 'click' },
    },
    completions: {
      ineligible: { element: 'post-accounts-completions-ineligible-user-close', type: 'click' },
      already_linked: { element: 'post-accounts-completions-already-linked-close', type: 'click' },
      invalid_partner_account_type: { element: 'post-accounts-completions-invalid-partner-acct-close', type: 'click' },
      invalid_partner: { element: 'post-accounts-completions-invalid-partner-acct-close', type: 'click' },
      enrolled_not_linked: {
        retry: { element: 'post-accounts-completions-system-error-relink', type: 'click' },
        close: { element: 'post-accounts-completions-system-error-relink-close', type: 'click' },
      },
      error: { element: 'post-accounts-completions-technical-error-close', type: 'click' },
      invalid_partner_session: { element: 'session-expired', type: 'click' },
    },
    success: {
      backToVenmo: { element: 'confirmation-back-to-venmo', type: 'click' },
      backToPayPal: { element: 'confirmation-back-to-paypal', type: 'click' },
    },
  },
  VERIFY: {
    sendCode: { element: 'authentication-send-code', type: 'click' },
    authCancel: { element: 'authentication-cancel', type: 'click' },
    getNewCode: { element: 'authentication-otp-get-new-code', type: 'click' },
    cancelCode: { element: 'authentication-otp-cancel', type: 'click' },
    confirmCode: { element: 'authentication-otp-confirmation', type: 'click' },
    incorrectCode: { element: 'authentication-otp-incorrect-code', type: 'click' },
    inncorrectCodeMax: { element: 'authentication-otp-incorrect-code-max', type: 'click' },
  },
};

export default LOG_EVENTS;
